import { css } from 'styled-components';

export const EventStyles = css`
  .b-sch-event-wrap {
    z-index: 2;
    padding-right: 2px;
    &.b-active .b-sch-event {
      outline: none;
    }

    &.hide-content .content {
      opacity: 0;
    }

    &.hide-more-actions {
      .more-actions-container {
        display: none;
      }
    }
  }
  .b-sch-event {
    border-radius: 4px;

    .more-actions-container {
      position: absolute;
      right: var(--spacing-03);
      top: 4px;
      .ant-btn {
        border-radius: 2px;
        background-color: var(--cyan-50);
        border-color: var(--cyan-50);
        &:hover {
          background-color: var(--cyan-60);
          border-color: var(--cyan-60);
        }
      }
      .ant-dropdown-trigger:not(.ant-dropdown-open) {
        visibility: hidden;
      }
    }

    &:hover:not(.splitMode) .more-actions-container .ant-dropdown-trigger {
      visibility: visible;
    }
    &:not(.b-milestone) .b-sch-event-content {
      margin: 0;
    }
    .b-sch-event-content {
      color: var(--gray-100) !important;
      margin: 0;
      width: 100%;
      height: 100%;
      font-weight: var(--font-weight-normal);
      align-items: center;
      .content {
        width: 100%;
        padding-left: var(--spacing-03);
        font-size: var(--font-size-sm);
      }
    }
    &.b-sch-event-selected .b-sch-event-content .content {
      color: var(--gray-100) !important;
      font-weight: var(--font-weight-normal);
    }
  }
`;
